import React from 'react'

import View from './View'

export default function SupportModal({ open, handleClose }) {
  return <View actions={{ handleClose }} state={{ open }} />
}
